"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrlParams = exports.overrideNativeMethod = void 0;
/**
 *
 * @param {String} methodName
 * @param {Function|null} oldMethod
 * @param {Object} parentObj //依赖的上一层父对象,主要用来检测是否configrable
 * @param {Function} cb  //回调函数
 */
exports.overrideNativeMethod = function (methodName, oldMethod, parentObj, cb) {
    if (parentObj === void 0) { parentObj = window || global; }
    if (typeof methodName !== 'string' || !parentObj)
        return;
    var property = Object.getOwnPropertyDescriptor(parentObj, methodName);
    if (property && typeof property.configrable !== 'undefined' && !property.configurable)
        return;
    var _oldMethod = oldMethod;
    oldMethod = function () {
        cb && cb.apply(this, arguments);
        return _oldMethod && _oldMethod.apply(this, arguments);
    };
    try {
        /** 有些属性可能writable false,readonly */
        parentObj[methodName] = oldMethod;
    }
    catch (e) {
        /** 修改劫持get */
        Object.defineProperty(parentObj, methodName, __assign(__assign({}, property), { get: function () {
                return oldMethod;
            } }));
    }
};
/*
 * 将类似window.location.search转换成object
 */
function formatUrlParams(search) {
    var urlSearch = window.location.search.substring(1) || window.location.hash.split('?')[1] || '';
    if (!urlSearch.length)
        return;
    var arrs = decodeURI(urlSearch).split('&');
    return arrs.reduce(function (prev, cur) {
        var _a = cur.split('='), key = _a[0], value = _a[1];
        prev[key] = value;
        return prev;
    }, {})[search];
}
exports.formatUrlParams = formatUrlParams;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/sensor-sdk-h5/dist/util.js
// module id = O0Id
// module chunks = 1